let currentDeviceType;

function getDeviceType() {
    return currentDeviceType || 'desktop';
}

function init (deviceType) {
    currentDeviceType = deviceType;
}

export default {init, getDeviceType};



// WEBPACK FOOTER //
// ./js/modules/privates/formFactor.es6